import { useEffect, useState } from 'react';
import Markdown from 'react-markdown';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { dark } from 'react-syntax-highlighter/dist/esm/styles/prism';
import { docco } from 'react-syntax-highlighter/dist/esm/styles/hljs';
import rehypeRaw from "rehype-raw";
import rehypeKatex from 'rehype-katex';
import remarkMath from 'remark-math'
import remarkGfm from 'remark-gfm';
import 'katex/dist/katex.min.css' // `rehype-katex` does not import the CSS for you
import './CustomMarkDown.css';
import Iconify from '../Iconify';

export function CodeCopyBtn({ children }) {
    const [copyOk, setCopyOk] = useState(false);
    const iconColor = copyOk ? '#0af20a' : '#ddd';
    const icon = copyOk ? 'fa-check-square' : 'fa-copy';
    const handleClick = (e) => {
        console.log(children);
        navigator.clipboard.writeText(children.props.children);
        setCopyOk(true);
        setTimeout(() => {
            setCopyOk(false);
        }, 5000);
    }
    return (
        <>
            <div className="code-copy-btn" >
                <Iconify onClick={handleClick} icon={copyOk ? 'solar:clipboard-check-linear' : 'tabler:clipboard'} />
            </div>
        </>
    )
}

export default function CustomMarkDown({ content }) {

    const Pre = ({ children }) => <>
            <pre className="blog-pre">
                <CodeCopyBtn>{children}</CodeCopyBtn>
                {children}
            </pre>
        </>


    return (
        <>
            <Markdown
                className={'reactMarkDown'}
                remarkPlugins={[remarkMath, remarkGfm]}
                rehypePlugins={[rehypeKatex, rehypeRaw]}
                children={content}
                components={{
                    pre: Pre,
                    code(props) {
                        const { children, className, node, ...rest } = props;
                        console.log('code props', props);
                        const match = /language-(\w+)/.exec(className || '');
                        return (
                            <SyntaxHighlighter
                                {...rest}
                                children={String(children).replace(/\n$/, '')}
                                style={dark}
                                language={match ? match[1] : 'bash'}
                                PreTag="div"
                            />
                        )
                    },
                    table: ({ node, ...props }) => <table className="myCustomTableClass" {...props} />,
                    th: ({ node, ...props }) => <th className="myCustomTableHeaderClass" {...props} />,
                    td: ({ node, ...props }) => <td className="myCustomTableCellClass" {...props} />,
                }}
            />
        </>
    )
}